var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.13,
    height: 17.889,
    viewBox: "22464.559 -7340.615 20.13 17.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22478.627-7337.71 3.152 3.152a.342.342 0 0 1 0 .482l-7.632 7.632-3.243.36a.68.68 0 0 1-.75-.752l.36-3.242 7.63-7.632a.342.342 0 0 1 .483 0Zm5.661-.8-1.705-1.706a1.367 1.367 0 0 0-1.93 0l-1.236 1.237a.342.342 0 0 0 0 .483l3.152 3.152c.133.132.35.132.482 0l1.237-1.237a1.367 1.367 0 0 0 0-1.93Zm-6.31 9.99v3.557h-11.183v-11.182h8.03a.43.43 0 0 0 .297-.122l1.398-1.398a.42.42 0 0 0-.297-.716h-9.987c-.926 0-1.677.751-1.677 1.677v12.3c0 .927.75 1.678 1.677 1.678h12.3c.926 0 1.678-.751 1.678-1.677v-5.515a.42.42 0 0 0-.717-.297l-1.398 1.398a.43.43 0 0 0-.122.297Z",
    fill: "#a1a3ef",
    fillRule: "evenodd",
    "data-name": "Icon awesome-edit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconTable);
export default __webpack_public_path__ + "static/media/editIconTable.578f3704605cb0ece20ea5873ed39f2c.svg";
export { ForwardRef as ReactComponent };